import React from 'react';
import blogCover from '../images/b3.png';
import blogCover2 from '../images/news5.jpeg';
import OurPartner from '../pages/components/OurPartner';
import SuggestedBlogs from './components/SuggestedBlogs';

import { FaUser, FaCalendarAlt, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { features } from "./components/BlogSection";
import { Link } from "react-router-dom";

const currentIndex = features.findIndex(
    (blog) => blog.link === "/saas-web-application-development"
);

const prevBlog = features[currentIndex - 1];
const nextBlog = features[currentIndex + 1];

function SaaSWebApplicationDevelopment() {

    const postDate = "July 25, 2026";

    return (
        <>
            {/* BLOG HEADER */}
            <section className="container my-5">

                <div className="text-center mb-4">

                    <h1 className="fw-bold responsive-heading mb-3">
                        <span className="highlight-orange">
                            How Peregrinee Builds SaaS Web Applications
                        </span>
                    </h1>

                    <p className="mt-3 text-muted fs-5">
                        Learn how Peregrinee designs and develops scalable SaaS platforms
                        with secure architecture, subscription models, and cloud-ready infrastructure.
                    </p>

                    <div className="d-flex justify-content-center align-items-center gap-4 mt-3 text-muted">

                        <span className="d-flex align-items-center gap-2">
                            <FaUser />
                            Posted by <strong>Peregrinee</strong>
                        </span>

                        <span className="d-flex align-items-center gap-2">
                            <FaCalendarAlt />
                            {postDate}
                        </span>

                    </div>

                </div>

            </section>


            {/* HERO IMAGE */}
            <section className="container mb-5">

                <img
                    src={blogCover}
                    alt="SaaS Web Application Development"
                    className="img-fluid rounded-4 shadow w-100"
                    style={{ maxHeight: "500px", objectFit: "cover" }}
                />

            </section>


            {/* SECTION 1 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6">

                        <img
                            src={blogCover}
                            alt="SaaS Platform Architecture"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                    <div className="col-lg-6">

                        <h3 className="fw-bold highlight-orange">
                            What is a SaaS Web Application?
                        </h3>

                        <p>
                            Software as a Service (SaaS) applications are cloud-based
                            platforms that users access through a web browser.
                            Instead of installing software locally, businesses
                            subscribe to the platform and access it online.
                        </p>

                        <h3 className="fw-bold highlight-orange mt-4">
                            Core Characteristics of SaaS Platforms
                        </h3>

                        <ul className="ps-3">
                            <li>Cloud-based infrastructure</li>
                            <li>Subscription-based billing models</li>
                            <li>Multi-tenant architecture</li>
                            <li>Continuous updates and maintenance</li>
                            <li>High scalability for growing users</li>
                        </ul>

                        <p className="mt-3">
                            SaaS platforms are widely used across industries
                            including fintech, education, productivity tools,
                            and enterprise management systems.
                        </p>

                    </div>

                </div>

            </section>


            {/* SECTION 2 */}
            <section className="container my-5 shadow-sm p-4 p-lg-5 rounded-4 bg-white">

                <div className="row align-items-center gy-4">

                    <div className="col-lg-6 order-lg-1 order-2">

                        <h3 className="fw-bold highlight-orange">
                            Peregrinee’s SaaS Development Process
                        </h3>

                        <p>
                            Peregrinee follows a structured approach to build
                            scalable SaaS platforms that are secure,
                            performance-optimized, and ready for growth.
                        </p>

                        <ul className="ps-3">
                            <li>Product strategy and SaaS architecture planning</li>
                            <li>Cloud infrastructure design</li>
                            <li>Scalable frontend and backend development</li>
                            <li>Secure authentication and role management</li>
                            <li>Subscription and billing integration</li>
                        </ul>

                        <p className="mt-3">
                            This process ensures that SaaS platforms remain
                            reliable and capable of scaling as user demand grows.
                        </p>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold mt-3"
                            style={{ width: "fit-content" }}
                        >
                            Discuss Your SaaS Idea
                        </a>

                    </div>

                    <div className="col-lg-6 order-lg-2 order-1">

                        <img
                            src={blogCover2}
                            alt="SaaS Cloud Infrastructure"
                            className="img-fluid rounded-4 shadow-sm w-100"
                            style={{ objectFit: "cover", maxHeight: "420px" }}
                        />

                    </div>

                </div>

            </section>


            {/* SECTION 3 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Essential Features of a SaaS Platform
                </h2>

                <ul className="ps-3">
                    <li>User authentication and access control</li>
                    <li>Subscription and payment management</li>
                    <li>Admin dashboards and analytics</li>
                    <li>Data security and encryption</li>
                    <li>API integrations with third-party services</li>
                </ul>

                <p className="mt-3">
                    These features ensure smooth operations and provide
                    a seamless experience for end users.
                </p>

            </section>


            {/* SECTION 4 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Technologies Used for SaaS Development
                </h2>

                <ul className="ps-3">
                    <li>Modern JavaScript frameworks like React</li>
                    <li>Node.js or scalable backend services</li>
                    <li>Cloud platforms such as AWS or Google Cloud</li>
                    <li>Database solutions like PostgreSQL or MongoDB</li>
                    <li>Containerization and DevOps automation</li>
                </ul>

                <p className="mt-3">
                    Peregrinee selects technologies based on the
                    scalability and performance requirements of the platform.
                </p>

            </section>


            {/* SECTION 5 */}
            <section className="container my-5 shadow-sm p-5 rounded-4 bg-white">

                <h2 className="fw-bold highlight-orange mb-4 text-center">
                    Building Scalable SaaS Platforms for the Future
                </h2>

                <p>
                    Successful SaaS platforms must support growing users,
                    evolving features, and continuous improvements.
                </p>

                <p>
                    Peregrinee focuses on building SaaS applications
                    with scalable architecture and reliable cloud
                    infrastructure to ensure long-term growth.
                </p>

                <div className="text-center mt-4">

                    <a
                        href="/contact-us"
                        className="btn btn-orange rounded-pill px-5 py-3 fw-bold"
                        style={{ width: "fit-content" }}
                    >
                        Start Building Your SaaS Platform
                    </a>

                </div>

            </section>


            {/* BLOG NAVIGATION */}
            <section className="container my-5">

                <div className="row">

                    {prevBlog && (
                        <div className="col-md-6 mb-3">

                            <Link
                                to={prevBlog.link}
                                className="d-flex align-items-center gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <FaArrowLeft />

                                <div>
                                    <small className="text-muted">Previous Blog</small>
                                    <h6 className="mb-0 fw-bold">{prevBlog.title}</h6>
                                </div>

                            </Link>

                        </div>
                    )}

                    {nextBlog && (
                        <div className="col-md-6 mb-3 text-md-end">

                            <Link
                                to={nextBlog.link}
                                className="d-flex align-items-center justify-content-md-end gap-3 p-3 border rounded-4 text-decoration-none blog-nav"
                            >

                                <div>
                                    <small className="text-muted">Next Blog</small>
                                    <h6 className="mb-0 fw-bold">{nextBlog.title}</h6>
                                </div>

                                <FaArrowRight />

                            </Link>

                        </div>
                    )}

                </div>

            </section>


            <SuggestedBlogs />

            <OurPartner />

        </>
    );
}

export default SaaSWebApplicationDevelopment;